import styles from "./LoginInfoMessageContainer.module.scss";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";

import classnames from "classnames";

export const LoginMessageContainer: (
  props: LoginMessageProps,
) => JSX.Element = (props) => {
  const {
    messageTitle,
    messageContent,
    messageIconUrl,
    messageIconDarkUrl,
    messageIconAlt,
  } = props;

  return (
    <div className={classnames(styles.messageContainer)}>
      <ImageWithFallback
        className={styles.messageIcon}
        fallbackImage={null}
        width={48}
        height={48}
        alt={messageIconAlt ?? ""}
        src={messageIconUrl}
        darkModeSrc={messageIconDarkUrl ?? messageIconUrl}
      />
      <div className={styles.messageTextContainer}>
        <p className="title-7-bold">{messageTitle}</p>
        <p className="text-4">{messageContent}</p>
      </div>
    </div>
  );
};

export interface LoginMessageProps {
  messageTitle: string;
  messageContent: string;
  messageIconUrl: string;
  messageIconDarkUrl?: string;
  messageIconAlt?: string;
}
